<template>
    <template v-for="menuItem in this.modelsData" v-bind:key="menuItem">
        <div class="scv-dropdown-menu-button">
            <label class="dropdown-item">
                <input type="checkbox"
                       v-bind:disabled="menuItem.disabled"
                       v-model="menuItem.checked"
                       @change="onChangeMenuItem(menuItem)"
                       autocomplete="off"
                       style="margin-right: 8px">
                <span> {{ menuItem.description }}</span>
            </label>
        </div>
    </template>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import { MenuItemBase } from '@/models/MenuItemBase';
    import { cloneDeep } from 'lodash';

    @Options({
        props: {
            models: { type: Array, Default: {} }, // メニューリスト : Array<MenuItemBase>
        },
        watch: {
            models: {
                handler: function () {
                    this.modelsData = cloneDeep(this.models)
                },
                deep: true,     // オブジェクトの監視
                immediate: true
            }
        },
        emits: [
            /*
             * リストチェック変更発生時
             * @param[in]   menuItemID チェックされているメニューリストのID
             */
            'onChangeMenuItem',
        ],
    })

    /*
    *  【SelectMenuの説明】
    *  メニューリスト作成を行います
    *  childMenuItem（★★★サブメニュは対応しておりません。★★★）
    *
    *  【SelectMenuの使い方（基本）】
    *  メニューリストの定義
    *  private readonly menuItemList: Array<MenuItemBase> =
    *       [
    *          { menuItemID: 0 , childMenuItem: [★未対応★], description: "Menue1", disabled: false//メニュー押下を無効にするかどうか checked: false//デフォルトチェックかどうか },
    *          { menuItemID: 1 , childMenuItem: [★未対応★], description: "Menue2", disabled: true//メニュー押下を無効にするかどうか  checked: true//デフォルトチェックかどうか },
    *           ...
    *       ];
    *
    *  チェック押下時の処理を実装
    *  // 
    *  // チェック押下時
    *  //
    *  private onChangeMenuItem(checkedIdList: number[]): void {
    *      if (checkedIdList.includes(0// menuItemID)) {
    *          ...
    *   }
    *      else {
    *          ...
    *      }
    *      return ;
    *  }
    *
    * HTMLで定義
    *      <SelectMenu :models="menuItemList" @onChangeMenuItem="onChangeMenuItem" />
    */
    export default class SelectMenu extends Vue {

        private modelsData: Array<MenuItemBase> = new Array<MenuItemBase>();

        // props
        private models!: Array<MenuItemBase>;

        public onChangeMenuItem(menuItemID: number): void {

            // チェックボタンが押下されているものだけ取り出す
            let checkedIdList: number[] = [];
            this.modelsData.filter((x) => x.checked == true).forEach(x => {
                checkedIdList.push(x.menuItemID);
            });

            // 昇順ソート
            checkedIdList.sort((a, b) => {
                return a - b;
            });

            this.$emit("onChangeMenuItem", checkedIdList);
        }
    }

</script>
